// `value` is the PhoneInput value (see Utils/phone/readPhone.js).
export const validatePhone = (value, t) => {
  if (!value?.number?.trim()) {
    return t("Phone number is required")
  }

  if (!value?.valid) {
    return t("Please enter a valid phone number")
  }

  return null
}
